export class Step4 {
	public intitule = 'stepper.form.simp_at.step4';

	public getattributionMarche = 'form.simp_at.getattributionMarche';

	constructor() {}
}
